<template>
  <div>
    <v-row class="farmer_teal ma-0 white--text py-2">
      <v-col cols="12" class="">
        <h2>Become a customer</h2>
        <p class="mb-0">Create an account and get in contact with suppliers, explore the whole catalog, save your favorite products and many more. </p>
      </v-col>
    </v-row>

    <v-row v-if="error">
      <v-col>
        <v-card class="elevation-8">
          <app-alert-error @dismissed="onDismiss" :text="error.message"></app-alert-error>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card class="mt-1" flat>
          <v-card-text>
            <v-container>
              <v-form lazy-validation v-model="valid" ref="form" @submit.prevent="onSignUp">
                <v-row no-gutters>
                  <v-col cols="12" sm="5">
                    <v-text-field label="First Name" name="firstName" type="text" :rules="fieldRules('First Name', 30)" v-model="customer.firstName" dense regular required outlined></v-text-field>
                  </v-col>
                  <v-col align="start" cols="12" sm="6" offset-sm="1">
                    <v-text-field label="Last Name" name="lastName" type="text" :rules="fieldRules('Last Name', 30)" v-model="customer.lastName" dense required outlined></v-text-field>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col>
                    <v-text-field color="farmer_green" label="E-mail" type="email" name="email" id="email" :rules="fieldRules('E-mail', 50)" v-model="customer.email" dense required outlined></v-text-field>
                    <v-text-field color="farmer_green" label="Password" :type="show ? 'text' : 'password'" :append-icon="show ? 'visibility_off' : 'visibility'" name="password" id="password" :rules="fieldRules('Password', 20)" v-model="password" @click:append="show = !show" required dense outlined></v-text-field>
                    <v-text-field color="primary" label="Confirm Password" :type="show ? 'text' : 'password'" :append-icon="show ? 'visibility_off' : 'visibility'" name="confirmPassword" id="confirmPassword" :rules="comparePasswords" v-model="confirmPassword" @click:append="show = !show" dense outlined></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-btn block class="farmer_teal mt-2 white--text" type="submit" :disabled="isLoading" :loading="isLoading" @click="loader = 'loading'">Sign up</v-btn>

                    <div class="hr-sect">or</div>

                    <v-btn block to="/sign-in" color="farmer_green" class="my-2 white--text">Already have an account? Login</v-btn>

                    <v-btn block color="red" class="mt-2 white--text" @click.prevent="onSignInWithGoogle" :disabled="isGLoading" :loading="isGLoading">
                      <v-icon left dark>fa-google-plus</v-icon>Login with Google
                    </v-btn>

                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { store } from '@/store'
import { mapGetters } from 'vuex'

export default {
  data: () => ({
    isLoading: false,
    isGLoading: false,
    isFLoading: false,
    valid: true,
    customer: {},
    show: false,
    password: '',
    confirmPassword: ''
    // checkbox: false
  }),
  computed: {
    ...mapGetters(['error']),
    comparePasswords() {
      return [p => p === this.password || 'Passwords do not match']
    },
    fieldRules() {
      return (fieldName, maxChar) => [
        v => (!!v && !!v.trim()) || `${fieldName} is required`,
        v =>
          (v && v.length <= maxChar) ||
          `${fieldName} must be less than ${maxChar} characters`
      ]
    }
  },

  methods: {
    onSignUp() {
      if (this.$refs.form.validate()) {
        this.isLoading = true
        const newCustomer = { ...this.customer, password: this.password }
        store.dispatch('signUserUp', newCustomer)
          .then(() => {
            this.isLoading = false
          })
          .catch(err => {
            this.isLoading = false
            store.commit('setError', err)
          })
      }
    },
    onSignInWithGoogle() {
      this.isGLoading = true
      store.dispatch('signUserInWithGoogle')
        .then(() => {
          this.isGLoading = false
        }).catch(() => {
          this.isGLoading = false
        })
    }
  },

  mounted() {
    store.commit('clearError')
  }
}
</script>

<style scoped>
.hr-sect {
  display: flex;
  flex-basis: 100%;
  align-items: center;
  margin: 8px 0px;
}
.hr-sect::before,
.hr-sect::after {
  content: "";
  flex-grow: 1;
  background: rgba(0, 0, 0, 0.35);
  height: 1px;
  font-size: 0px;
  line-height: 0px;
  margin: 0px 8px;
}
</style>
